import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { Redirect } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Save from "@material-ui/icons/Save";
import Delete from "@material-ui/icons/Delete";
import DatePicker from 'material-ui-pickers/DatePicker';

import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';

import moment from 'moment';
import { childrenRef } from '../../firebase';
import { FormControl } from '@material-ui/core';

import { toast } from "react-toastify";
import { AppBar, Toolbar, TextField } from "@material-ui/core";

const styles = theme => ({
    title: {
        paddingLeft: '2%',
        paddingRight: '5%',
        paddingTop: '2%',
        paddingBottom: '5rem',
    },
    close: {
        width: theme.spacing.unit * 4,
        height: theme.spacing.unit * 4,
    },
    floatRight: {
        float: "right"
    },
    width100: {
        width: "100%"
    },
    width50: {
        width: "50%"
    },
    marginright: { marginRight: 5 }
});

class AddKid extends Component {
    constructor(props) {
        super(props);

        const { id } = props.match.params;
        let mode = false;

        if (id) {
            mode = true;
        }

        this.onSubmit = this.onSubmit.bind(this);

        this.state = {
            saving: false,
            dob: moment(),
            gender: 'male',
            firstName: '',
            firstNameError: false,
            lastName: '',
            lastNameError: false,
            accountId: '',
            accountIdNameError: false,
            //location: '',
            state: '',
            street: '',
            zipCode: '',
            zipCodeError: false,
            city: '',
            parentId: this.props.myId,
            formStatus: false,
            childCreatedStatus: false,
            childErrorStatus: false,
            mode: mode,
            loading: mode,
            open: false,
        }
        if (mode) {
            childrenRef.doc(id).get()
                .then((doc) => {
                    var data = doc.data();
                    /* console.log(data);
                    for (var property in data) {
                        console.log(property + ':' + data[property]);
                        this.setState({property: data[property]});
                    } */
                    this.setState({ dob: moment(data['dob'], 'MM/DD/YYYY') });
                    this.setState({ gender: data['gender'] });
                    this.setState({ firstName: data['firstName'], lastName: data['lastName'] });
                    this.setState({ accountId: data['accountId'] });
                    //this.setState({ location: data['location'] });
                    this.setState({ state: data['state'] });
                    this.setState({ street: data['street'] });
                    this.setState({ zipCode: data['zipCode'] });
                    this.setState({ city: data['city'] });
                    this.setState({ loading: false });
                    this.setState({ id: id });
                    this.setState({ saveDate: moment().format('MM/DD/YYYY, h:mm:ss a') });
                });
        }
    }

    onSubmit(e) {
        e.preventDefault();

        if (!this.state.saving) {
            if (this.state.firstName === '' || this.state.lastName === '' || this.state.accountId === '' ||
                this.state.state === '' || this.state.zipCode === '' || this.state.city === '') {
                /*
                this.state.location === '' ||
                 
                Push.create("KBAAZ", {
                    body: "Please fillout all fields!!!",
                    logo: './k-logo.png',
                    timeout: 4000,
                    onClick: function() {
                        window.focus();
                        this.close();
                    }
                }); */
                toast.warn('Please fill out all fields!', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });
                const kidData = {
                    firstName: this.state.firstName,
                    lastName: this.state.lastName,
                    gender: this.state.gender,
                    dob: this.state.dob.format('MM/DD/YYYY'),
                    accountId: this.state.accountId,
                    //location: this.state.location,
                    state: this.state.state,
                    street: this.state.street,
                    zipCode: this.state.zipCode,
                    city: this.state.city,
                    parentId: 'test',
                    saveDate: moment().format('MM/DD/YYYY, h:mm:ss a'),
                    deposit: 0
                };

                console.log(kidData);

            } else {
                this.setState({ saving: true });
                const kidData = {
                    firstName: this.state.firstName,
                    lastName: this.state.lastName,
                    gender: this.state.gender,
                    dob: this.state.dob.format('MM/DD/YYYY'),
                    accountId: this.state.accountId,
                    //location: this.state.location,
                    state: this.state.state,
                    street: this.state.street,
                    zipCode: this.state.zipCode,
                    city: this.state.city,
                    parentId: this.props.myId,
                    saveDate: moment().format('MM/DD/YYYY, h:mm:ss a'),
                    deposit: 0
                };

                if (!this.state.mode) {
                    childrenRef.add(kidData)
                        .then(() => {
                            /* Push.create("KBAAZ", {
                                body: "Child saved successfully",
                                logo: './k-logo.png',
                                timeout: 4000,
                                onClick: function () {
                                    window.focus();
                                    this.close();
                                }
                            }); */
                            toast.success('Child saved successfully!', {
                                position: "bottom-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true
                            });
                            this.setState({ saving: false });
                            this.setState({ redirect: true });
                        })
                        .catch(() => {
                            /* Push.create("KBAAZ", {
                                body: "Error occurred",
                                logo: './k-logo.png',
                                timeout: 4000,
                                onClick: function () {
                                    window.focus();
                                    this.close();
                                }
                            }); */
                            toast.error('Error occurred!', {
                                position: "bottom-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true
                            });
                            this.setState({ saving: false });
                        });
                } else {
                    childrenRef.doc(this.state.id).set(kidData)
                        .then(() => {
                            /* Push.create("KBAAZ", {
                                body: "Child saved successfully",
                                logo: './k-logo.png',
                                timeout: 4000,
                                onClick: function () {
                                    window.focus();
                                    this.close();
                                }
                            }); */
                            toast.success('Child saved successfully!', {
                                position: "bottom-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true
                            });
                            this.setState({ saving: false });
                            this.setState({ redirect: true });
                        })
                        .catch(() => {
                            /* Push.create("KBAAZ", {
                                body: "Error occurred",
                                logo: './k-logo.png',
                                timeout: 4000,
                                onClick: function () {
                                    window.focus();
                                    this.close();
                                }
                            }); */
                            toast.error('Error occurred!', {
                                position: "bottom-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true
                            });
                            this.setState({ saving: false });
                        });
                }
            }
        }
    }

    handleChange = name => event => {

        var value = event.target.value;

        /*         if (name === 'firstName' || name === 'lastName') {
                    if(value.length > 20) {
                        toast.success('First name or last name must be less than 20 chars!', {
                            position: "bottom-right",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                        save = false;
                    }
                } else if(name === 'accountId') {
                    if (value.length > 20) {
                        toast.success('Account number must be less than 20 chars!', {
                            position: "bottom-right",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                        save = false;
                    }
                } else if(name === 'zipCode') {
                }
        
                if(save) {
                    this.setState({
                        [name]: value,
                    });
                } */
        this.setState({
            [name]: value
        });
    };

    handleDateChange = (date) => {
        this.setState({ dob: date });
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    deleteChild = () => {
        this.setState({ open: false });
        childrenRef.doc(this.state.id).delete()
            .then(() => {
                /* Push.create("KBAAZ", {
                    body: "Child deleted successfully!!!",
                    logo: './k-logo.png',
                    timeout: 4000,
                    onClick: function () {
                        window.focus();
                        this.close();
                    }
                }); */
                toast.success('Child deleted succesfully!', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });
                this.setState({
                    redirect: true
                });
            })
            .catch(() => {
                /* Push.create("KBAAZ", {
                    body: "Some error occurred!!!",
                    logo: './k-logo.png',
                    timeout: 4000,
                    onClick: function () {
                        window.focus();
                        this.close();
                    }
                }); */
                toast.error('Some error occurred!', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });
            });
    }

    componentWillMount() {
        ValidatorForm.addValidationRule('isNameValid', (value) => {
            if (value.length > 20) {
                return false;
            }
            return true;
        });

        /*  ValidatorForm.addValidationRule('isPhoneValid', (value) => {
             if (value.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im)) {
                 return true;
             }
             return false;
         });
  */
        ValidatorForm.addValidationRule('isZipValid', (value) => {
            if (value.match(/(^\d{5}$)|(^\d{5}-\d{4}$)/)) {
                return true;
            }
            return false;
        });
    }

    render() {
        const { classes } = this.props;

        if (this.state.redirect) {
            return (
                <Redirect to="/kids" />
            );
        }

        if (this.state.loading) {
            return (
                <h2>Loading...</h2>
            );
        }

        return (
            <div className={classes.title}>
                <ValidatorForm
                    ref="form"
                    onSubmit={this.onSubmit}
                >
                    <Grid container spacing={40} style={{ paddingBottom: '50px' }}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <AppBar position="static">
                                <Toolbar>
                                    <div className={classes.width50}>
                                        {this.state.mode ? "Update Kid Details" : "Kid Details"}
                                    </div>
                                    <div className={classes.width50 + " " + classes.floatRight}>
                                        {this.state.mode && (
                                            <Button
                                                onClick={this.handleClickOpen}
                                                variant="outlined"
                                                color="primary"
                                                style={{
                                                    color: "#ffffff",
                                                    backgroundColor: "#FE008F"
                                                }}
                                                className={classes.floatRight}
                                            >
                                                <Delete /> DELETE
                      </Button>
                                        )}
                                        <Button
                                            type="submit"
                                            color="primary"
                                            style={{
                                                color: "#ffffff",
                                                backgroundColor: "#FE008F"
                                            }}
                                            variant="outlined"
                                            className={classes.floatRight + " " + classes.marginright}
                                        >
                                            <Save /> Save
                    </Button>
                                    </div>
                                </Toolbar>
                            </AppBar>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                            {/* <TextField value={this.state.firstName} onChange={this.handleChange('firstName')} style={{width:'80%'}} label={"Firstname"}/> */}
                            <TextValidator
                                style={{ width: '80%' }}
                                label="FirstName"
                                onChange={this.handleChange('firstName')}
                                name="firstname"
                                value={this.state.firstName}
                                validators={['required', 'isNameValid']}
                                errorMessages={['this field is required', 'must be less than 20 chars']}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                            <TextValidator
                                style={{ width: '80%' }}
                                label="LastName"
                                onChange={this.handleChange('lastName')}
                                name="lastname"
                                value={this.state.lastName}
                                validators={['required', 'isNameValid']}
                                errorMessages={['this field is required', 'must be less than 20 chars']}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                            <FormControl style={{ width: '80%' }}>
                                <InputLabel htmlFor='gender-select'>Gender</InputLabel>
                                <Select
                                    value={this.state.gender}
                                    onChange={this.handleChange('gender')}
                                    inputProps={{
                                        id: 'gender-select',
                                    }}
                                >
                                    <MenuItem value={'male'}>Male</MenuItem>
                                    <MenuItem value={'female'}>Female</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                            <DatePicker
                                disableFuture
                                value={this.state.dob}
                                onChange={this.handleDateChange}
                                style={{ width: '80%' }}
                                label="Date of Birth"
                                format="MM/DD/YYYY"
                                placeholder="10/10/2018"
                                keyboard
                                mask={value => (value ? [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/] : [])}
                                disableOpenOnEnter
                                animateYearScrolling={false}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography
                                color="primary"
                                gutterBottom={false}
                                variant="display1"
                            >
                                529 Account Number
              </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <TextValidator
                                style={{ width: '80%' }}
                                label="Acount Number"
                                onChange={this.handleChange('accountId')}
                                name="accountId"
                                value={this.state.accountId}
                                validators={['required', 'isNameValid']}
                                errorMessages={['this field is required', 'must be less than 20 chars']}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography gutterBottom={false} color="primary" variant="display1">Administrator Mailing Address</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
                            <Grid item xs={12} lg={6} xl={6}>
                                <TextValidator
                                    style={{
                                        marginRight: "5%",
                                        width: "40%",
                                        paddingBottom: "5px"
                                    }}
                                    label="Zip Code"
                                    onChange={this.handleChange("zipCode")}
                                    name="zipcode"
                                    value={this.state.zipCode}
                                    validators={["required", "isZipValid"]}
                                    errorMessages={[
                                        "this field is required",
                                        "enter a valid zip code"
                                    ]}
                                />

                                <TextValidator
                                    label="State"
                                    onChange={this.handleChange("state")}
                                    name="state"
                                    value={this.state.state}
                                    validators={["required", "isNameValid"]}
                                    errorMessages={[
                                        "this field is required",
                                        "must be less than 20 chars"
                                    ]}
                                    style={{ width: "40%", paddingBottom: "10px" }}
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            style={{ paddingTop: "0px" }}
                            item
                            xs={12}
                            sm={6}
                            md={6}
                            lg={6}
                            xl={6}
                        >
                            <TextValidator
                                style={{ width: "88%", paddingBottom: "20px" }}
                                label="Street"
                                onChange={this.handleChange("street")}
                                name="street"
                                value={this.state.street}
                                validators={["isNameValid"]}
                                errorMessages={["must be less than 20 chars"]}
                            />

                            <TextValidator
                                style={{ width: "88%" }}
                                label="City"
                                onChange={this.handleChange("city")}
                                name="city"
                                value={this.state.city}
                                validators={["required", "isNameValid"]}
                                errorMessages={[
                                    "this field is required",
                                    "must be less than 20 chars"
                                ]}
                            />
                        </Grid>
                    </Grid>

                    {this.state.mode && (
                        <Dialog
                            open={this.state.open}
                            onClose={this.handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Alert!!!"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete? This is action is
                                    irreversible
                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.deleteChild} color="primary">
                                    Yes
                </Button>
                                <Button onClick={this.handleClose} color="primary" autoFocus>
                                    No
                </Button>
                            </DialogActions>
                        </Dialog>
                    )}
                </ValidatorForm>
            </div>
        );
    }
}

AddKid.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(AddKid);



// WEBPACK FOOTER //
// ./src/components/Kids/AddKid.js